import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { CLIENT_ROUTES, INPUTS_PROPS } from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import {
  getErrorMessage,
  isRequired,
  isValidPassword,
} from "../../../../../utils/FormUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import PasswordInput from "../../../Inputs/CustomInputs/PasswordInput";
import classes from "./LoginForm.module.css";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { useSelector } from "react-redux";

const ResetPasswordForm = (props) => {
  const isShowLoadingSpinner = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );
  const [formData, setFormData] = useState({
    newPassword: "",
    repeatPassword: "",
    isCurrentStepValid: false,
    isStepSubmitted: false,
  });
  const [errors, setErrors] = useState({});
  const [submitErrors, setSubmitErrors] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleChange = (newProp) => {
    setSubmitErrors("");
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setFormData({ ...formData, isCurrentStepValid: !hasError });
  };

  const validateForm = () => {
    const passwordValidation = isValidPassword(
      formData.newPassword,
      formData.repeatPassword
    );
    if (!passwordValidation.isValid) {
      setSubmitErrors(passwordValidation.errorMessage);
    }
    handleError({
      [INPUTS_PROPS.NEW_PASSWORD]: !passwordValidation.isValid,
    });
    return passwordValidation.isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const isValidForm = validateForm();
    if (isValidForm && formData.isCurrentStepValid) {
      actionsService
        .resetPassword(props.userId, formData.newPassword)
        .then((response) => {
          if (response.data.isSuccess) {
          } else {
            setSubmitErrors(response?.data?.error?.errorTitle);
          }
        })
        .catch((error) => {});
      setSuccessMessage("Password has been change, Click To Login");
    }
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  return (
    <div className={classes.loginForm}>
      {!showForm && (
        <>
          <div className={classes.title}>{Strings.RESET_PASSWORD}</div>
          <div className={classes.subTitle}>
            {Strings.RESET_PASSWORD_MESSAGE}
          </div>
          <div className={classes.loginButton}>
            <EllipseButton onClick={handleShowForm}>
              {Strings.RESET_PASSWORD}
            </EllipseButton>
          </div>
          <div className={classes.message}>
            {Strings.RESET_PASSWORD_VALIDATION_MESSAGE}
          </div>
        </>
      )}
      {showForm && !(formData.isStepSubmitted && successMessage) && (
        <>
          <div className={classes.title}>{Strings.RESET_PASSWORD}</div>
          <div className={classes.subTitle}>
            {Strings.RESET_PASSWORD_INSTRUCTION}
          </div>

          <form name="ResetPassword" onSubmit={handleSubmit}>
            <div className={classes.fileds}>
              <PasswordInput
                label={Strings.INPUT_LABELS.NEW_PASSWORD}
                id={INPUTS_PROPS.NEW_PASSWORD}
                value={formData.newPassword}
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(formData.newPassword).isValid}
                errorMessage={getErrorMessage(isRequired(formData.newPassword))}
              />
              <PasswordInput
                label={Strings.INPUT_LABELS.REPEAT_PASSWORD}
                id={INPUTS_PROPS.REPEAT_PASSWORD}
                value={formData.repeatPassword}
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(formData.repeatPassword).isValid}
                errorMessage={getErrorMessage(
                  isRequired(formData.repeatPassword)
                )}
              />
            </div>

            <div className={classes.loginButton}>
              <EllipseButton type="submit">
                {Strings.SAVE_NEW_PASSWORD}
              </EllipseButton>
            </div>
          </form>
        </>
      )}
      {formData.isStepSubmitted && submitErrors && (
        <div className={classes.error}>{submitErrors}</div>
      )}

      {formData.isStepSubmitted && successMessage && (
        <NavLink to={CLIENT_ROUTES.LOGIN}>
          <Button
            disabled={isShowLoadingSpinner}
            className={classes.forgetPasswordButton}
          >
            {successMessage}
          </Button>
        </NavLink>
      )}
    </div>
  );
};

export default ResetPasswordForm;
